/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationValueDto } from './CreateEnumerationValueDto';
import {
    CreateEnumerationValueDtoFromJSON,
    CreateEnumerationValueDtoFromJSONTyped,
    CreateEnumerationValueDtoToJSON,
} from './CreateEnumerationValueDto';
import type { CreateNumericListDto } from './CreateNumericListDto';
import {
    CreateNumericListDtoFromJSON,
    CreateNumericListDtoFromJSONTyped,
    CreateNumericListDtoToJSON,
} from './CreateNumericListDto';
import type { CreateNumericValueDto } from './CreateNumericValueDto';
import {
    CreateNumericValueDtoFromJSON,
    CreateNumericValueDtoFromJSONTyped,
    CreateNumericValueDtoToJSON,
} from './CreateNumericValueDto';

/**
 * 
 * @export
 * @interface CreatePhotonBeamQualityDto
 */
export interface CreatePhotonBeamQualityDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualityDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualityDto
     */
    name?: string | null;
    /**
     * 
     * @type {CreateNumericListDto}
     * @memberof CreatePhotonBeamQualityDto
     */
    availableDoseRates: CreateNumericListDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreatePhotonBeamQualityDto
     */
    energy: CreateNumericValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreatePhotonBeamQualityDto
     */
    radiationType: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreatePhotonBeamQualityDto
     */
    highDoseTechniqueType: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreatePhotonBeamQualityDto
     */
    primaryFluenceShaping: CreateEnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof CreatePhotonBeamQualityDto
     */
    $type?: CreatePhotonBeamQualityDtoTypeEnum;
}


/**
 * @export
 */
export const CreatePhotonBeamQualityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationCreatePhotonBeamQualityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreatePhotonBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreatePhotonBeamQualityDtoTypeEnum = typeof CreatePhotonBeamQualityDtoTypeEnum[keyof typeof CreatePhotonBeamQualityDtoTypeEnum];


/**
 * Check if a given object implements the CreatePhotonBeamQualityDto interface.
 */
export function instanceOfCreatePhotonBeamQualityDto(value?: unknown): value is CreatePhotonBeamQualityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreatePhotonBeamQualityDtoTypeEnum)[0];
}

export function CreatePhotonBeamQualityDtoFromJSON(json: any): CreatePhotonBeamQualityDto {
    return CreatePhotonBeamQualityDtoFromJSONTyped(json, false);
}

export function CreatePhotonBeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePhotonBeamQualityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'availableDoseRates': CreateNumericListDtoFromJSON(json['availableDoseRates']),
        'energy': CreateNumericValueDtoFromJSON(json['energy']),
        'radiationType': CreateEnumerationValueDtoFromJSON(json['radiationType']),
        'highDoseTechniqueType': CreateEnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        'primaryFluenceShaping': CreateEnumerationValueDtoFromJSON(json['primaryFluenceShaping']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreatePhotonBeamQualityDtoToJSON(value?: CreatePhotonBeamQualityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'availableDoseRates': CreateNumericListDtoToJSON(value.availableDoseRates),
        'energy': CreateNumericValueDtoToJSON(value.energy),
        'radiationType': CreateEnumerationValueDtoToJSON(value.radiationType),
        'highDoseTechniqueType': CreateEnumerationValueDtoToJSON(value.highDoseTechniqueType),
        'primaryFluenceShaping': CreateEnumerationValueDtoToJSON(value.primaryFluenceShaping),
        '$type': value.$type,
    });
}

